import EmailStudentModal from './EmailStudentModal'
import { SendEmailInput, useSendEmailMutation } from '../../../generated/graphql'
import useModal from '../../../lib/hooks/useModal'

type EmailStudentModalWrapperProps = {
  /** Flag to denote whether the modal is open or not */
  isOpen: boolean
  /** Default 'To' email address */
  toEmailAddress?: string
}

const EmailStudentModalWrapper = ({ isOpen, toEmailAddress }: EmailStudentModalWrapperProps) => {
  const { hideModal } = useModal()
  const [sendEmail] = useSendEmailMutation()

  const onCancel = () => {
    hideModal()
  }

  const onSend = (input: SendEmailInput) => {
    // ToEmail and Message are required
    if (input.toEmail && input.message) {
      hideModal()
      sendEmail({
        variables: { input }
      })
    }
  }

  return (
    <EmailStudentModal
      isOpen={isOpen}
      onCancel={onCancel}
      onSend={onSend}
      toEmailAddress={toEmailAddress}
    />
  )
}

export default EmailStudentModalWrapper
